import React, { Component } from 'react'
import * as PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { conciliationOperations } from '../../../../state/ducks/conciliations'
import { PaginationSizeLayout, TableGeneratedLayout } from '../../../layouts'
import { PaginationLayout } from '../../../layouts/pagination'

class ConciliationConciliationTableGenerated extends Component {
  constructor (props) {
    super(props)

    // state
    this.state = {
      fullPage: false,
      queryParams: {}
    }

    this.getConciliationTableGenerated = this.getConciliationTableGenerated.bind(this)
    this.fullPage = this.fullPage.bind(this)
    this.getConciliationTableGenerated = this.getConciliationTableGenerated.bind(this)
    this.onPaginationChange = this.onPaginationChange.bind(this)
    this.onPaginationSizeChange = this.onPaginationSizeChange.bind(this)
    this.onSortBy = this.onSortBy.bind(this)
  }

  componentDidUpdate (prevProps, prevState, snapshot) {
    if (!this.state.queryParams.connection_id) {
      this.setState({
        queryParams: {
          connection_id: this.props.conciliation.destination_connection,
          table_name: this.props.conciliation.name + '__VIEW'
        }
      }, () => {
        if (!this.props.isLoading) {
          this.props.getConciliationTableGenerated(this.state.queryParams)
        }
      })
    }
  }

  getConciliationTableGenerated () {
    this.props.getConciliationTableGenerated(this.state.queryParams)
  }

  fullPage (fullPage) {
    const currentValue = this.state.fullPage
    if (currentValue) {
      fullPage = null
    }
    this.setState({ fullPage })
  }

  updateQueryParams (key, value) {
    const { queryParams } = this.state
    queryParams[key] = value
    if (key === 'search') {
      queryParams.page = 1
    }
    this.setState({ queryParams }, () => this.getConciliationTableGenerated())
  }

  onPaginationSizeChange (size) {
    this.updateQueryParams('pagination_size', size)
  }

  onSortBy (att, sortBy) {
    this.updateQueryParams('ordering', sortBy === -1 ? '-' + att : att)
  }

  onPaginationChange (page) {
    this.updateQueryParams('page', page)
  }

  render () {
    return (
            <>
                <div className={
                    ' block block-themed block-opt-refresh-icon7 ' +
                    (this.props.isLoading ? ' block-opt-refresh ' : '') +
                    (this.state.fullPage ? ' block-opt-fullscreen ' : '')
                }>
                    <div className="block-header bg-primary-dark">
                        <ul className="block-options">
                            <li>
                                <button type="button"
                                        onClick={this.fullPage.bind('loaded-table')}
                                >
                                    <i className="si si-size-fullscreen"/>
                                </button>
                            </li>
                            <li>
                                <button type="button">
                                    <i className="fa fa-download"/>
                                </button>
                            </li>
                            <li>
                                <button type="button"
                                        data-toggle="block-option"
                                        onClick={this.getConciliationTableGenerated}
                                >
                                    <i className="si si-refresh"></i>
                                </button>
                            </li>
                        </ul>
                        <h3 className="block-title">{this.props.conciliation.name + '__VIEW'}</h3>
                    </div>
                    <div className="block-content">
                        {/* Pagination Size */}
                        <PaginationSizeLayout
                            onPaginationSizeChange={this.onPaginationSizeChange}/>
                        {/* End Pagination Size */}
                        <div className="table-scrolling">
                            {/* Table */}
                            <TableGeneratedLayout
                                rows={this.props.conciliationTableGenerated}
                                onSortBy={this.onSortBy}
                            />
                            {/* End Table */}
                        </div>
                        {/* Pagination */}
                        <PaginationLayout
                            pagination={this.props.paginationData}
                            onPaginationChange={this.onPaginationChange}
                        />
                        {/* End Pagination */}
                    </div>
                </div>
            </>
    )
  }
}

// Set propTypes
ConciliationConciliationTableGenerated.propTypes = {
  conciliation: PropTypes.object.isRequired,
  conciliationTableGenerated: PropTypes.array,
  isLoading: PropTypes.bool,
  paginationData: PropTypes.object
}

// Set defaultProps
ConciliationConciliationTableGenerated.defaultProps = {
  conciliation: {},
  conciliationTableGenerated: [],
  isLoading: true,
  paginationData: {}
}

// mapStateToProps
const mapStateToProps = (state) => ({
  conciliationTableGenerated: state.conciliations.conciliationTableGeneratedReducer.data.results,
  isLoading: state.conciliations.conciliationTableGeneratedReducer.loading,
  paginationData: state.conciliations.conciliationTableGeneratedReducer.data.pagination_data
})

// mapStateToProps
const mapDispatchToProps = {
  getConciliationTableGenerated: conciliationOperations.getConciliationTableGenerated
}

// Export Class
const _ConciliationConciliationTableGenerated = connect(mapStateToProps,
  mapDispatchToProps)(ConciliationConciliationTableGenerated)
export { _ConciliationConciliationTableGenerated as ConciliationConciliationTableGenerated }
